import type { IdentityUserManager } from '@uipath/auth-core';
import type { PropsWithChildren } from 'react';
import React from 'react';

interface AuthContextProps {
    userManager: IdentityUserManager;
}

export const AuthPropsContext = React.createContext<AuthContextProps>({ userManager: {} as any });

export const useUserManager = () => React.useContext(AuthPropsContext).userManager;

/**
 * provides additional props to auth components
 * @param signinComplete - handles all sign in scenarios
 * @returns `JSX.Element`
 */
export const AuthPropsProvider = ({
    children, userManager,
}: PropsWithChildren<AuthContextProps>) => (
    <AuthPropsContext.Provider
        value={{ userManager }}>
        {children}
    </AuthPropsContext.Provider>
);
